export const ScanFlag = {
  IS_SCAN_LOGIN: 1, // 1 is scan login
  NOT_SCAN_LOGIN: 0 // 0 is not scan login
}



// WEBPACK FOOTER //
// ./src/new-login-2018/common/GeneralVariable.js